import {ChangeDetectorRef, Component, forwardRef, OnInit} from '@angular/core';
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {SessionActions} from "../../../shared/actions";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../user/user.service";
import {IUser} from "../../../shared/redux-store/session/session.types";
import {appInjector} from "../../../";
import {FORM_ERROR_MESSAGES} from "../../../core/visbos-core/assets/form-error-messages";
import {ApolloQueryObservable} from "apollo-angular";

@Component({
  selector: 'vb-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => UserFormComponent)}]
})
export class UserFormComponent extends AbstractVisbosControl<IUser, FormGroup> implements OnInit {

  enumLabel = (item) => item;
  enumId = (item) => item;

  private formsOfAddresses$: ApolloQueryObservable<any>;
  public formsOfAddresses: string[];

  private academicTitles$: ApolloQueryObservable<any>;
  public academicTitles: string[];

  errorDefs = FORM_ERROR_MESSAGES;

  selectedAdminUnitCuids: string[];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions,
              private userService: UserService) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();

    this.formsOfAddresses$ = this.userService.getFormsOfAddresses();
    this.addComponentData(this.formsOfAddresses$);
    this.addSubscription(this.formsOfAddresses$.subscribe(res => {
      this.formsOfAddresses = res.data.forms_of_addresses;
    }));

    this.academicTitles$ = this.userService.getAcademicTitles();
    this.addComponentData(this.academicTitles$);
    this.addSubscription(this.academicTitles$.subscribe(res => {
      this.academicTitles = res.data.academic_titles;
    }));
  }

  buildControlContent(values?: IUser, ...params): FormGroup {
    return UserFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      form_of_address: [null],
      academic_title: [null],
      pre_name: [null],
      name: [null, Validators.required],
      email: [null, Validators.email],
      roles: fb.array([], Validators.required),
      administration_unit_cuids: fb.array([], Validators.required)
    });

  }

  public setDefaultValues(item?: IUser): { [controlKey: string]: any } | any {

    this.selectedAdminUnitCuids = item && item.administration_units ? item.administration_units.map(a => a.cuid) : [];

    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      form_of_address: this.setValue(item, 'form_of_address'),
      academic_title: this.setValue(item, 'academic_title'),
      pre_name: this.setValue(item, 'pre_name'),
      name: this.setValue(item, 'name'),
      email: this.setValue(item, 'email'),
    };
  }

  onSelectedAdminUnitsChanged(selectedAdminUnitCuids?: string[]) {
    let auCtrl = this.control.get('administration_unit_cuids') as FormArray;
    auCtrl.controls = [];
    auCtrl.reset();

    for (let cuid of selectedAdminUnitCuids) {
      auCtrl.push(this.fb.control(cuid));
    }

    if (selectedAdminUnitCuids) {
      auCtrl.markAsTouched();
    }

    this.cd.detectChanges();
  }

  onSelectedRolesChanged(selectedRoles?: string[]) {
    let roleCtrl = this.control.get('roles') as FormArray;
    roleCtrl.controls = [];
    roleCtrl.reset();

    for (let name of selectedRoles) {
      roleCtrl.push(this.fb.control(name));
    }

    if (selectedRoles) {
      roleCtrl.markAsTouched();
    }

    this.cd.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/user-form/user-form.component.ts